export default "__VITE_ASSET__BaQfv9JB__"